import React, { useState } from "react";
import { Typography, TableContainer, Box, Paper, Checkbox, FormControlLabel, useTheme, useMediaQuery } from '@mui/material';

/**
 * 支払い完了しましたチェックボックス
 * @param formRef
 * @returns
 */
export const PayCompleteConfirm = (inputRef: any) => {
  // 初期値をinputRefから取得
  const [localValue, setLocalValue] = useState<boolean>(inputRef.isPayCompleteRef.current || false);

  // レスポンシブデザイン設定
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // モバイル画面の条件設定

  // 入力変更時に親コンポーネントに値を通知
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.checked; // チェックボックスの状態を取得
    setLocalValue(newValue); // ローカルの状態を更新
    if (inputRef.isPayCompleteRef.current !== null) {
      inputRef.isPayCompleteRef.current = newValue; // useRefの値を更新
    }
  };

  return (
    <>
      <TableContainer component={Paper} sx={{ border: '1px solid #DDDDDD', margin: "20px auto", backgroundColor: '' }}>
        {/* "確認"バー */}
        <Typography
          sx={{
            color: '#fff',
            backgroundColor: '#3f51b5',
            padding: isMobile ? '8px' : '10px', // モバイルではパディングを少し小さくする
            textAlign: 'center',
            borderRadius: '5px',
          }}
        >
          確認
        </Typography>

        {/* 入力エリア */}
        <Box sx={{ display: 'flex', justifyContent: 'center', padding: isMobile ? '12px' : '20px' }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={localValue}
                onChange={handleInputChange}
                color="primary"
              />
            }
            label="支払いが完了しました"
            sx={{
              fontSize: isMobile ? '14px' : '16px', // モバイルではフォントサイズを少し小さく
            }}
          />
        </Box>
      </TableContainer>
    </>
  );
};
